import { createSelector } from 'reselect';
import _sample from 'lodash/sample';

export const getColors = ({ colors }) => colors.data;

export const getRandomColor = createSelector(
  getColors,
  colors => _sample(colors),
);
